import { render, staticRenderFns } from "./JournalVoucherView.vue?vue&type=template&id=31732c53&"
import script from "./JournalVoucherView.vue?vue&type=script&lang=js&"
export * from "./JournalVoucherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports